export const translations = {
  en: {
    nav: {
      intro: 'Introduction',
      characters: 'Characters',
      quotes: 'Quotes',
      quiz: 'Personality Quiz',
      features: 'Features',
      explore: 'Explore the Show Content'
    },
    home: {
      title: 'Malcolm in the Middle',
      subtitle: 'A Classic Family Comedy',
      description: 'Explore the crazy life of Malcolm and his family',
      welcome: 'Welcome to Malcolm in the Middle',
      welcomeDesc: 'Explore this crazy yet heartwarming family story, and relive those hilarious moments.',
      about: 'About the Show',
      aboutText: 'This show follows the daily life of a middle-class family, told through the perspective of Malcolm, a gifted teenager.\n\n' +
        'First Season (2000):\n' +
        'Malcolm discovering his genius status and transfer to the gifted class, while his eldest brother Francis rebels at military school.\n\n' +
        'Second Season (2000-2001):\n' +
        'Delves deeper into family dynamics, exploring Malcolm\'s teenage struggles, Reese\'s culinary talents, and Hal\'s unique interactions with the kids.\n\n' +
        'Third Season (2001-2002):\n' +
        'Witnesses major family changes, including a memorable family vacation, Lois\'s unexpected pregnancy, and Francis finding new work in Alaska.\n\n' +
        'Fourth Season (2002-2003):\n' +
        'Welcomes new family member Jamie, while showcasing Malcolm\'s psychological challenges and Hal\'s racing car dreams.\n\n' +
        'Fifth Season (2003-2004):\n' +
        'Brings major transitions with Francis starting a new life at the ranch, Reese\'s impulsive military enlistment, and Malcolm\'s first work experience.\n\n' +
        'Sixth Season (2004-2005):\n' +
        'Complicates family dynamics with Grandma Ida moving in, Dewey\'s musical talents flourishing, and Malcolm preparing for college applications.\n\n' +
        'Final Season 7 (2005-2006):\n' +
        'The final season presents pivotal moments for each character: Malcolm\'s Harvard acceptance, Reese finding his path, and the family facing future changes together.\n\n' +
        'The show is renowned for its unique narrative style, outstanding performances, and witty script that reveals both the joy and challenges of family life.',
      aboutTextEn: 'This show follows the daily life of a middle-class family, told through the perspective of Malcolm, a gifted teenager.\n\n' +
        'Season 1 (2000):\n' +
        'Malcolm discovers his genius status and transfer to the gifted class, while his eldest brother Francis rebels at military school.\n\n' +
        'Season 2 (2000-2001):\n' +
        'Delves deeper into family dynamics, exploring Malcolm\'s teenage struggles, Reese\'s culinary talents, and Hal\'s unique interactions with the kids.\n\n' +
        'Season 3 (2001-2002):\n' +
        'Witnesses major family changes, including a memorable family vacation, Lois\'s unexpected pregnancy, and Francis finding new work in Alaska.\n\n' +
        'Season 4 (2002-2003):\n' +
        'Welcomes new family member Jamie, while showcasing Malcolm\'s psychological challenges and Hal\'s racing car dreams.\n\n' +
        'Season 5 (2003-2004):\n' +
        'Brings major transitions with Francis starting a new life at the ranch, Reese\'s impulsive military enlistment, and Malcolm\'s first work experience.\n\n' +
        'Season 6 (2004-2005):\n' +
        'Complicates family dynamics with Grandma Ida moving in, Dewey\'s musical talents flourishing, and Malcolm preparing for college applications.\n\n' +
        'Season 7 (2005-2006):\n' +
        'The final season presents pivotal moments for each character: Malcolm\'s Harvard acceptance, Reese finding his path, and the family facing future changes together.\n\n' +
        'The show is renowned for its unique narrative style, outstanding performances, and witty script that reveals both the joy and challenges of family life.',
      features: 'Show Features',
      awards: 'Awards & Recognition',
      awardsText: 'The show has received numerous accolades, including 7 Emmy Awards, a Grammy Award, and a Peabody Award. Bryan Cranston received 3 Emmy nominations for his role as Hal, while the show was consistently praised for its innovative storytelling and outstanding ensemble cast performance.',
      contact: 'For suggestions, please email: garygxm@gmail.com'
    },
    quiz: {
      title: 'Which Character Are You?',
      start: 'Start Quiz',
      next: 'Next Question',
      result: 'View Result',
      disclaimer: 'This quiz is for entertainment purposes only. Everyone is unique and should not take the results too seriously.',
      matchLevel: 'Match Level',
      traits: 'Character Traits',
      retake: 'Take Quiz Again',
      question: 'Question',
      questionNumber: 'Question {{current}}/{{total}}',
      allMatches: 'All Character Matches',
      recommendedEpisodes: 'Recommended Episodes',
      seasonEpisode: 'Season {{season}} Episode {{episode}}',
      similarCharacters: 'Similar Characters',
      questions: {
        daily: 'What do you usually do?',
        difficulty: 'How do you handle difficulties?',
        weekend: 'What do you want to do on weekends?',
        strength: 'What do you think is your greatest strength?',
        familyRole: 'What role do you usually play in the family?',
        lifestyle: 'What lifestyle do you aspire to?',
        rules: "What's your attitude towards rules?",
        hobby: "What's your favorite leisure activity?"
      }
    },
    characters: {
      title: 'Character Profiles',
      subtitle: 'Learn about each unique character',
      traits: 'Traits',
      memorableMoments: 'Memorable Moments',
      actor: 'Played by',
      descriptions: {
        malcolm: 'Malcolm is the third of five brothers with a genius IQ (165). Known for his witty observations and sharp social commentary, he often breaks the fourth wall to share his insights about family, society, and life\'s absurdities. While his intelligence helps him understand the world around him, it also makes him acutely aware of life\'s complexities and ironies.',
        dewey: 'Dewey is the fourth of five brothers, with Francis, Reese, and Malcolm as his older brothers and Jamie as his younger brother. Despite being often overlooked, he shows amazing musical talent, adaptability, and creativity. His unique imagination and artistic abilities make him stand out in this chaotic family.',
        reese: 'Reese is the second oldest of five brothers, between Francis and Malcolm. Despite poor academic performance, he shows extraordinary talent in cooking. Though often causing trouble, he occasionally displays unexpected wisdom and loyalty to his brothers.',
        francis: 'Francis is the eldest of five brothers. His rebellious nature led him to military school, where he experienced multiple life changes. His conflicts with his mother and personal growth illustrate the complexity of family relationships.',
        jamie: 'Jamie is the youngest of the five brothers, born in the fourth season. Despite being the baby of the family, he quickly adapts to the chaotic household dynamics. His arrival adds new dimensions to family relationships and often becomes the center of both mischief and affection.',
        lois: 'As the mother of five boys, Lois is strict but loving. She maintains family order under difficult conditions, dealing with Francis\'s rebellion, Reese\'s troublemaking, Malcolm\'s genius, Dewey\'s creativity, and Jamie\'s growing years.',
        hal: 'Father Hal may seem overwhelmed with five sons, but he is full of wisdom and love. His unique parenting style and unconditional support show a different form of fatherly love, often finding creative ways to connect with each of his very different boys.'
      }
    },
    quotes: {
      title: 'Classic Quotes',
      season: 'Season',
      episode: 'Episode',
      character: 'Character',
      seasonTitle: 'Season {{number}} Classic Quotes'
    },
    footer: {
      about: 'About',
      aboutText: 'This site is dedicated to sharing content from Malcolm in the Middle. All content is from public sources for learning and communication purposes. This site has no affiliation with the original production team, and all rights belong to the original copyright holders.',
      contact: 'Contact',
      disclaimer: 'If any content infringes copyright, please contact us for removal.'
    }
  },
  zh: {
    nav: {
      intro: '剧集介绍',
      characters: '角色介绍',
      quotes: '经典台词',
      quiz: '性格测试',
      features: '功能导航',
      explore: '探索剧集内容'
    },
    home: {
      title: 'Malcolm一家',
      subtitle: '经典家庭喜剧',
      description: '探索Malcolm和他家人的疯狂生活',
      welcome: '欢迎来到Malcolm一家',
      welcomeDesc: '探索这个疯狂又温馨的家庭故事，重温那些令人捧腹的欢乐时光。',
      about: '关于剧集',
      aboutText: '这部剧讲述了一个中产阶级家庭的日常生活，以天才少年Malcolm的视角展现了这个独特家庭的点点滴滴。\n\n' +
        '第一季（2000年）：\n' +
        'Malcolm发现自己是天才儿童，被调到天才班，同时大哥Francis在军事学校的叛逆生活。\n\n' +
        '第二季（2000-2001年）：\n' +
        '深入探讨家庭关系，包括Malcolm的青春期困惑、Reese展现出的烹饪天赋，以及Hal与孩子们的独特互动。\n\n' +
        '第三季（2001-2002年）：\n' +
        '见证了家庭的重大变化，包括一次难忘的家庭度假、Lois意外怀孕的消息，以及Francis在阿拉斯加找到新工作。\n\n' +
        '第四季（2002-2003年）：\n' +
        '迎来家里的新成员Jamie，同时展现了Malcolm的心理困扰、Hal追逐赛车梦想等故事。\n\n' +
        '第五季（2003-2004年）：\n' +
        'Francis在牧场开始新生活，Reese一时冲动参军，Malcolm则开始初次工作体验。\n\n' +
        '第六季（2004-2005年）：\n' +
        '家庭关系更加复杂，外婆Ida的搬入带来新的家庭动态，Dewey的音乐才能得到充分展现，Malcolm则开始为大学申请做准备。\n\n' +
        '第七季（2005-2006年）：\n' +
        '作为最终季，展现了每个角色的重要转折：Malcolm获得哈佛录取、Reese寻找人生方向、全家人共同面对未来的改变。\n\n' +
        '剧集以其独特的叙事方式、出色的表演和充满智慧的剧本而闻名，真实展现了家庭生活中的欢乐与挑战。',
      aboutTextEn: 'This show follows the daily life of a middle-class family, told through the perspective of Malcolm, a gifted teenager.\n\n' +
        'Season 1 (2000):\n' +
        'Malcolm discovers his genius status and transfer to the gifted class, while his eldest brother Francis rebels at military school.\n\n' +
        'Season 2 (2000-2001):\n' +
        'Delves deeper into family dynamics, exploring Malcolm\'s teenage struggles, Reese\'s culinary talents, and Hal\'s unique interactions with the kids.\n\n' +
        'Season 3 (2001-2002):\n' +
        'Witnesses major family changes, including a memorable family vacation, Lois\'s unexpected pregnancy, and Francis finding new work in Alaska.\n\n' +
        'Season 4 (2002-2003):\n' +
        'Welcomes new family member Jamie, while showcasing Malcolm\'s psychological challenges and Hal\'s racing car dreams.\n\n' +
        'Season 5 (2003-2004):\n' +
        'Brings major transitions with Francis starting a new life at the ranch, Reese\'s impulsive military enlistment, and Malcolm\'s first work experience.\n\n' +
        'Season 6 (2004-2005):\n' +
        'Complicates family dynamics with Grandma Ida moving in, Dewey\'s musical talents flourishing, and Malcolm preparing for college applications.\n\n' +
        'Season 7 (2005-2006):\n' +
        'The final season presents pivotal moments for each character: Malcolm\'s Harvard acceptance, Reese finding his path, and the family facing future changes together.\n\n' +
        'The show is renowned for its unique narrative style, outstanding performances, and witty script that reveals both the joy and challenges of family life.',
      features: '剧集特色',
      awards: '获奖记录',
      awardsText: '该剧获得了众多奖项，包括7项艾美奖、一项格莱美奖和皮博迪奖。Bryan Cranston凭借饰演Hal一角获得3次艾美奖提名，剧集因其创新的叙事方式和出色的整体演出而受到一致好评。',
      contact: '有任何建议，请发送邮件至：garygxm@gmail.com'
    },
    quiz: {
      title: '你最像哪个角色?',
      start: '开始测试',
      next: '下一题',
      result: '查看结果',
      disclaimer: '本测试仅供娱乐，每个人都是独特的，请勿过分认真对待结果。',
      matchLevel: '匹配程度',
      traits: '性格特征',
      retake: '重新测试',
      question: '问题',
      questionNumber: '第 {{current}}/{{total}} 题',
      allMatches: '所有角色匹配度',
      recommendedEpisodes: '推荐剧集',
      seasonEpisode: '第{{season}}季第{{episode}}集',
      similarCharacters: '相似角色',
      questions: {
        daily: '你平时最常做什么？',
        difficulty: '你如何处理困难？',
        weekend: '周末你想做什么？',
        strength: '你认为自己最大的优点是什么？',
        familyRole: '你在家庭中通常扮演什么角色？',
        lifestyle: '你向往什么样的生活方式？',
        rules: '你对规则的态度是什么？',
        hobby: '你最喜欢的休闲活动是什么？'
      }
    },
    characters: {
      title: '角色介绍',
      subtitle: '了解每个角色背后的故事和特点',
      traits: '性格特点',
      memorableMoments: '经典时刻',
      actor: '演员',
      descriptions: {
        malcolm: 'Malcolm是五兄弟中的老三，拥有天才般的智商（IQ 165）。以其机智的观察和犀利的社会评论著称，他经常打破第四面墙，分享对家庭、社会和生活荒诞的见解。虽然他的智慧帮助他理解周围的世界，但也让他更深刻地意识到生活的复杂性和讽刺性。',
        dewey: 'Dewey是五兄弟中的老四，上面有Francis、Reese和Malcolm三个哥哥，下面还有小弟Jamie。虽然经常被哥哥们忽视，但他展现出惊人的音乐天赋、适应能力和创造力。他独特的想象力和艺术天赋使他在这个混乱的家庭中脱颖而出。',
        reese: 'Reese是五兄弟中的老二，排在Francis和Malcolm之间。虽然学习成绩不佳，但他展现出非凡的烹饪天赋。他经常制造麻烦，但有时也会显示出意想不到的智慧和对兄弟们的忠诚。',
        francis: 'Francis是五兄弟中的老大。他的叛逆性格导致他进入军事学校，在那里他经历了多次生活变化。他的冲突与他的母亲和个人的成长经历展现了家庭关系的复杂性。',
        jamie: 'Jamie是五兄弟中最小的，在第四季出生。虽然是家里最小的孩子，但他很快就适应了这个充满混乱的家庭氛围。他的到来为家庭关系增添了新的维度，经常成为恶作剧和宠爱的中心。',
        lois: '作为五个男孩的母亲，Lois是严格但充满爱心的。她在艰难的条件下努力维持家庭秩序，要应对Francis的叛逆、Reese的捣蛋、Malcolm的天才、Dewey的创造力和Jamie的成长。',
        hal: '作为五个儿子的父亲，Hal看似应付不来，实则充满智慧和爱心。他独特的教育方式和对家人的无条件支持展现了一种不同的父爱形式，总能找到创造性的方式去理解和联系每个性格迥异的孩子.'
      }
    },
    quotes: {
      title: '经典台词',
      season: '第',
      episode: '集',
      character: '角色',
      seasonTitle: '第{{number}}季经典台词'
    },
    footer: {
      about: '关于本站',
      aboutText: '本站是一个致力于分享《Malcolm in the Middle》剧集相关内容的网站。所有内容均来自互联网公开资源，仅供交流学习使用。本站与原剧集制作方无任何关联，所有版权归原版权方所有。',
      contact: '联系我们',
      disclaimer: '如有侵权，请联系我们删除。'
    }
  },
  ru: {
    nav: {
      intro: 'Введение',
      characters: 'Персонажи',
      quotes: 'Цитаты',
      quiz: 'Тест личности',
      features: 'Функции',
      explore: 'Исследовать содержание шоу'
    },
    home: {
      title: 'Малкольм в центре внимания',
      subtitle: 'Классическая семейная комедия',
      description: 'Исследуйте сумасшедшую жизнь Малкольма и его семьи',
      welcome: 'Добро пожаловать в "Малкольм в центре внимания"',
      welcomeDesc: 'Исследуйте эту сумасшедшую, но душевную семейную историю.',
      about: 'О сериале',
      aboutText: 'Этот сериал рассказывает о повседневной жизни семьи среднего класса глазами Малкольма, одаренного подростка.\n\n' +
        'Сезон 1 (2000):\n' +
        'Малкольм узнает о своих выдающихся способностях и переходит в класс для одаренных детей, в то время как его старший брат Фрэнсис бунтует в военной школе.\n\n' +
        'Сезон 2 (2000-2001):\n' +
        'Более глубокое исследование семейной динамики, включая подростковые проблемы Малкольма, кулинарные таланты Риса и уникальное взаимодействие Хэла с детьми.\n\n' +
        'Сезон 3 (2001-2002):\n' +
        'Важные изменения в семье, включая памятный семейный отпуск, неожиданную беременность Лоис и новую работу Фрэнсиса на Аляске.\n\n' +
        'Сезон 4 (2002-2003):\n' +
        'Появление нового члена семьи Джейми, психологические проблемы Малкольма и мечты Хэла о гонках.\n\n' +
        'Сезон 5 (2003-2004):\n' +
        'Большие перемены: Фрэнсис начинает новую жизнь на ранчо, Рис импульсивно уходит в армию, а Малкольм получает первый опыт работы.\n\n' +
        'Сезон 6 (2004-2005):\n' +
        'Усложнение семейной динамики с переездом бабушки Иды, расцвет музыкальных талантов Дьюи и подготовка Малкольма к поступлению в колледж.\n\n' +
        'Сезон 7 (2005-2006):\n' +
        'Финальный сезон представляет ключевые моменты для каждого персонажа: поступление Малкольма в Гарвард, Рис находит свой путь, а семья вместе встречает грядущие перемены.\n\n' +
        'Сериал известен своим уникальным стилем повествования, выдающейся актерской игрой и остроумным сценарием, который раскрывает как радости, так и сложности семейной жизни.',
      features: 'Особенности сериала',
      awards: 'Награды и признание',
      awardsText: 'Сериал получил множество наград, включая 7 премий Эмми, премию Грэмми и премию Пибоди. Брайан Крэнстон получил 3 номинации на Эмми за роль Хэла, а сериал постоянно получал похвалы за инновационное повествование и выдающуюся игру актёрского ансамбля.',
      contact: 'По предложениям пишите на: garygxm@gmail.com'
    },
    quiz: {
      title: 'На какого персонажа вы похожи?',
      start: 'Начать тест',
      next: 'Следующий вопрос',
      result: 'Посмотреть результат',
      disclaimer: 'Этот тест только для развлечения.',
      matchLevel: 'Уровень совпадения',
      traits: 'Черты характера',
      retake: 'Пройти тест снова',
      question: 'Вопрос',
      questionNumber: 'Вопрос {{current}}/{{total}}',
      allMatches: 'Все персонажи совпадают',
      recommendedEpisodes: 'Рекомендуемые эпизоды',
      seasonEpisode: 'Сезон {{season}} Эпизод {{episode}}',
      similarCharacters: 'Похожие персонажи',
      questions: {
        daily: 'Что вы обычно делаете?',
        difficulty: 'Как вы справляетесь с трудностями?',
        weekend: 'Что вы хотите делать на выходных?',
        strength: 'В чем, по-вашему, ваша главная сила?',
        familyRole: 'Какую роль вы обычно играете в семье?',
        lifestyle: 'К какому образу жизни вы стремитесь?',
        rules: 'Как вы относитесь к правилам?',
        hobby: 'Какое у вас любимое хобби?'
      }
    },
    characters: {
      title: 'Профили персонажей',
      subtitle: 'Узнайте о каждом уникальном персонаже',
      traits: 'Черты характера',
      memorableMoments: 'Памятные моменты',
      actor: 'В роли',
      descriptions: {
        malcolm: 'Малкольм - третий из пяти братьев с гениальным IQ (165). Известен своими остроумными наблюдениями и острыми социальными комментариями, часто обращается напрямую к зрителю, делясь своими мыслями о семье, обществе и жизненных абсурдах. Хотя его интеллект помогает ему понимать окружающий мир, он также делает его особенно чувствительным к сложностям и иронии жизни.',
        dewey: 'Дьюи - четвертый из пяти братьев, с Francis, Reese и Malcolm как aînés et Jamie comme cadet. Hoewel souvent négligé, il montre un talent musical étonnant, une capacité d\'adaptation et une créativité remarquable. Son imagination unique et ses capacités artistiques le distinguent dans cette famille chaotique.',
        reese: 'Рис - второй старший из пяти братьев, между Фрэнсисом и Малкольмом. Несмотря на плохую успеваемость в школе, он проявляет необычайный талант в кулинарии. Хотя он часто создает проблемы, иногда он проявляет неожиданную мудрость и преданность своим братьям.',
        francis: 'Фрэнсис - старший из пяти братьев. Его бунтарский характер привел его в военную школу, где он пережил множество жизненных перемен. Его конфликты с матерью и личностный рост иллюстрируют сложность семейных отношений.',
        jamie: 'Джейми - самый младший из пяти братьев, родившийся в четвертом сезоне. Несмотря на то, что он самый младший в семье, он быстро адаптируется к хаотичной семейной динамике. Его появление добавляет новые измерения в семейные отношения и часто становится центром как шалостей, так и привязанности.',
        lois: 'Как мать пятерых мальчиков, Лоис строгая, но любящая. Она поддерживает порядок в семье в сложных условиях, gранясь с бунтом Фрэнсиса, проделками Риса, гениальностью Малкольма, творчеством Дьюи и взрослением Джейми.',
        hal: 'Отец Хэл может казаться перегруженным с пятью сыновьями, но он полон мудрости и любви. Его уникальный стиль воспитания и безусловная поддержка показывают другую форму отцовской любви, часто находя творческие способы найти подход к каждому из своих очень разных сыновей.'
      }
    },
    quotes: {
      title: 'Классические цитаты',
      season: 'Сезон',
      episode: 'Эпизод',
      character: 'Персонаж',
      seasonTitle: 'Сезон {{number}} - Классические цитаты'
    },
    footer: {
      about: 'О сайте',
      aboutText: 'Этот сайт посвящен сериалу "Малкольм в центре внимания". Весь контент взят из публичных источников и предназначен для обучения и общения. Этот сайт не имеет отношения к оригинальной команде производства, все права принадлежат первоначальным правообладателям.',
      contact: 'Связаться с нами',
      disclaimer: 'При нарушении авторских прав свяжитесь с нами для удаления.'
    }
  },
  fr: {
    nav: {
      intro: 'Introduction',
      characters: 'Personnages',
      quotes: 'Citations',
      quiz: 'Test de personnalité',
      features: 'Fonctionnalités',
      explore: 'Explorer le contenu de la série'
    },
    home: {
      title: 'Malcolm',
      subtitle: 'Une comédie familiale classique',
      description: 'Explorez la vie folle de Malcolm et sa famille',
      welcome: 'Bienvenue dans Malcolm',
      welcomeDesc: 'Explorez cette histoire de famille folle mais attachante.',
      about: 'À propos de la série',
      aboutText: 'Cette série suit la vie quotidienne d\'une famille de classe moyenne à travers les yeux de Malcolm, un adolescent surdoué.\n\n' +
        'Saison 1 (2000):\n' +
        'Malcolm découvre son statut de génie et est transféré dans une classe pour surdoués, tandis que son frère aîné Francis se rebelle à l\'école militaire.\n\n' +
        'Saison 2 (2000-2001):\n' +
        'Exploration approfondie de la dynamique familiale, des difficultés adolescentes de Malcolm, des talents culinaires de Reese et des interactions uniques de Hal avec les enfants.\n\n' +
        'Saison 3 (2001-2002):\n' +
        'Changements majeurs dans la famille, incluant des vacances familiales mémorables, la grossesse inattendue de Lois et le nouveau travail de Francis en Alaska.\n\n' +
        'Saison 4 (2002-2003):\n' +
        'Arrivée du nouveau membre de la famille Jamie, défis psychologiques de Malcolm et rêves de course automobile de Hal.\n\n' +
        'Saison 5 (2003-2004):\n' +
        'Transitions importantes avec Francis commençant une nouvelle vie au ranch, l\'engagement impulsif de Reese dans l\'armée et la première expérience professionnelle de Malcolm.\n\n' +
        'Saison 6 (2004-2005):\n' +
        'Complexification de la dynamique familiale avec l\'emménagement de Grand-mère Ida, l\'épanouissement des talents musicaux de Dewey et la préparation de Malcolm pour l\'université.\n\n' +
        'Saison 7 (2005-2006):\n' +
        'La dernière saison présente des moments décisifs pour chaque personnage : l\'admission de Malcolm à Harvard, Reese trouvant sa voie, et la famille faisant face ensemble aux changements à venir.\n\n' +
        'La série est reconnue pour son style narratif unique, ses performances exceptionnelles et son scénario plein d\'esprit qui révèle à la fois les joies et les défis de la vie familiale.',
      features: 'Caractéristiques de la série',
      awards: 'Récompenses et reconnaissance',
      awardsText: 'La série a reçu de nombreuses récompenses, dont 7 Emmy Awards, un Grammy Award et un Peabody Award. Bryan Cranston a reçu 3 nominations aux Emmy pour son rôle de Hal, tandis que la série était constamment saluée pour sa narration innovante et sa performance d\'ensemble exceptionnelle.',
      contact: 'Pour toute suggestion, écrivez à : garygxm@gmail.com'
    },
    quiz: {
      title: 'Quel personnage êtes-vous ?',
      start: 'Commencer le test',
      next: 'Question suivante',
      result: 'Voir le résultat',
      disclaimer: 'Ce test est uniquement pour le divertissement.',
      matchLevel: 'Niveau de correspondance',
      traits: 'Traits de caractère',
      retake: 'Refaire le test',
      question: 'Question',
      questionNumber: 'Question {{current}}/{{total}}',
      allMatches: 'Tous les personnages correspondent',
      recommendedEpisodes: 'Épisodes recommandés',
      seasonEpisode: 'Épisode {{season}} de la saison {{episode}}',
      similarCharacters: 'Personnages similaires',
      questions: {
        daily: 'Que faites-vous habituellement ?',
        difficulty: 'Comment gérez-vous les difficultés ?',
        weekend: 'Que voulez-vous faire le week-end ?',
        strength: 'Quelle est votre plus grande force selon vous ?',
        familyRole: 'Quel rôle jouez-vous généralement dans la famille ?',
        lifestyle: 'Quel style de vie aspirez-vous ?',
        rules: 'Quelle est votre attitude envers les règles ?',
        hobby: 'Quelle est votre activité de loisir préférée ?'
      }
    },
    characters: {
      title: 'Profils des personnages',
      subtitle: 'Découvrez chaque personnage unique',
      traits: 'Traits de caractère',
      memorableMoments: 'Moments mémorables',
      actor: 'Joué par',
      descriptions: {
        malcolm: 'Malcolm est le troisième de cinq frères avec un QI de génie (165). Connu pour ses observations pleines d\'esprit et ses commentaires sociaux perspicaces, il brise souvent le quatrième mur pour partager ses réflexions sur la famille, la société et les absurdités de la vie. Bien que son intelligence l\'aide à comprendre le monde qui l\'entoure, elle le rend aussi particulièrement conscient des complexités et des ironies de la vie.',
        dewey: 'Dewey est le quatrième des cinq frères, avec Francis, Reese et Malcolm comme aînés et Jamie comme cadet. Hoewel souvent négligé, il montre un talent musical étonnant, une capacité d\'adaptation et une créativité remarquable. Son imagination unique et ses capacités artistiques le distinguent dans cette famille chaotique.',
        reese: 'Reese est le deuxième aîné des cinq frères, entre Francis et Malcolm. Malgré ses mauvais résultats scolaires, il montre un talent extraordinaire en cuisine. Hoewel il cause souvent des problèmes, il fait parfois preuve d\'une sagesse inattendue et d\'une loyauté envers ses frères.',
        francis: 'Francis est l\'aîné des cinq frères. Sa nature rebelle l\'a conduit à l\'école militaire, où il a connu de nombreux changements de vie. Ses conflits avec sa mère et son développement personnel illustrent la complexité des relations familiales.',
        jamie: 'Jamie est le plus jeune des cinq frères, né dans la quatrième saison. Hoewel il soit le bébé de la famille, il s\'adapte rapidement à la dynamique chaotique du foyer. Son arrivée ajoute de nouvelles dimensions aux relations familiales et devient souvent le centre des bêtises et de l\'affection.',
        lois: 'En tant que mère de cinq garçons, Lois est stricte mais aimante. Elle maintient l\'ordre familial dans des conditions difficiles, gérant la rébellion de Francis, les bêtises de Reese, le génie de Malcolm, la créativité de Dewey et les années de croissance de Jamie.',
        hal: 'Le père Hal peut sembler dépassé avec cinq fils, mais il est vol de sagesse et d\'amour. Son style parental unique et son soutien inconditionnel montrent une forme différente d\'amour paternel, trouvant souvent des moyens créatifs de se connecter avec chacun de ses garçons très différents.'
      }
    },
    quotes: {
      title: 'Citations classiques',
      season: 'Saison',
      episode: 'Épisode',
      character: 'Personnage',
      seasonTitle: 'Saison {{number}} - Citations classiques'
    },
    footer: {
      about: 'À propos',
      aboutText: 'Ce site est dédié à la série Malcolm. Tout le contenu provient de sources publiques à des fins d\'apprentissage et de communication. Ce site n\'a aucune affiliation avec l\'équipe de production originale, et tous les droits appartiennent aux détenteurs des droits d\'auteur originaux.',
      contact: 'Nous contacter',
      disclaimer: 'En cas de violation des droits d\'auteur, contactez-nous pour la suppression.'
    }
  },
  de: {
    nav: {
      intro: 'Einführung',
      characters: 'Charaktere',
      quotes: 'Zitate',
      quiz: 'Persönlichkeitstest',
      features: 'Funktionen',
      explore: 'Serieninhalt entdecken'
    },
    home: {
      title: 'Malcolm mittendrin',
      subtitle: 'Eine klassische Familienkomödie',
      description: 'Entdecken Sie das verrückte Leben von Malcolm und seiner Familie',
      welcome: 'Willkommen bei Malcolm mittendrin',
      welcomeDesc: 'Entdecken Sie diese verrückte, aber herzerwärmende Familiengeschichte.',
      about: 'Über die Serie',
      aboutText: 'Diese Serie folgt dem Alltag einer Mittelklassefamilie aus der Sicht von Malcolm, einem hochbegabten Teenager.\n\n' +
        'Staffel 1 (2000):\n' +
        'Malcolm entdeckt seinen Hochbegabten-Status und wechselt in die Begabtenklasse, während sein ältester Bruder Francis in der Militärschule rebelliert.\n\n' +
        'Staffel 2 (2000-2001):\n' +
        'Tieferer Einblick in die Familiendynamik, Malcolms Teenagerprobleme, Reeses kulinarische Talente und Hals einzigartige Interaktionen mit den Kindern.\n\n' +
        'Staffel 3 (2001-2002):\n' +
        'Große Familienveränderungen, einschließlich eines unvergesslichen Familienurlaubs, Lois\' unerwarteter Schwangerschaft und Francis\' neuer Arbeit in Alaska.\n\n' +
        'Staffel 4 (2002-2003):\n' +
        'Begrüßung des neuen Familienmitglieds Jamie, Malcolms psychologische Herausforderungen und Hals Rennwagenträume.\n\n' +
        'Staffel 5 (2003-2004):\n' +
        'Wichtige Übergänge mit Francis\' neuem Leben auf der Ranch, Reeses impulsivem Militärdienst und Malcolms erster Arbeitserfahrung.\n\n' +
        'Staffel 6 (2004-2005):\n' +
        'Komplexere Familiendynamik durch den Einzug von Oma Ida, Deweys aufblühende musikalische Talente und Malcolm bereitet sich auf die Universitätsbewerbungen vor.\n\n' +
        'Staffel 7 (2005-2006):\n' +
        'Die letzte Staffel zeigt entscheidende Momente für jeden Charakter: Malcolms Harvard-Aufnahme, Reese findet seinen Weg und die Familie stellt sich gemeinsam den kommenden Veränderungen.\n\n' +
        'Die Serie ist bekannt für ihren einzigartigen Erzählstil, herausragende Darstellungen und geistreiche Drehbücher, die sowohl die Freuden als auch die Herausforderungen des Familienlebens zeigen.',
      features: 'Show-Merkmale',
      awards: 'Auszeichnungen & Anerkennung',
      awardsText: 'Die Serie erhielt zahlreiche Auszeichnungen, darunter 7 Emmy Awards, einen Grammy Award und einen Peabody Award. Bryan Cranston erhielt 3 Emmy-Nominierungen für seine Rolle als Hal, während die Serie durchgehend für ihre innovative Erzählweise und herausragende Ensembleleistung gelobt wurde.',
      contact: 'Für Vorschläge schreiben Sie an: garygxm@gmail.com'
    },
    quiz: {
      title: 'Welcher Charakter bist du?',
      start: 'Test starten',
      next: 'Nächste Frage',
      result: 'Ergebnis anzeigen',
      disclaimer: 'Dieser Test dient nur der Unterhaltung.',
      matchLevel: 'Übereinstimmungsgrad',
      traits: 'Charaktereigenschaften',
      retake: 'Test wiederholen',
      question: 'Frage',
      questionNumber: 'Frage {{current}}/{{total}}',
      allMatches: 'Alle Charaktere passen',
      recommendedEpisodes: 'Empfohlene Episoden',
      seasonEpisode: 'Staffel {{season}} Episode {{episode}}',
      similarCharacters: 'Ähnliche Charaktere',
      questions: {
        daily: 'Was machst du normalerweise?',
        difficulty: 'Wie gehst du mit Schwierigkeiten um?',
        weekend: 'Was möchtest du am Wochenende machen?',
        strength: 'Was ist deiner Meinung nach deine größte Stärke?',
        familyRole: 'Welche Rolle spielst du normalerweise in der Familie?',
        lifestyle: 'Welchen Lebensstil strebst du an?',
        rules: 'Wie ist deine Einstellung zu Regeln?',
        hobby: 'Was ist deine liebste Freizeitbeschäftigung?'
      }
    },
    characters: {
      title: 'Charakterprofile',
      subtitle: 'Lernen Sie jeden einzigartigen Charakter kennen',
      traits: 'Charaktereigenschaften',
      memorableMoments: 'Denkwürdige Momente',
      actor: 'Gespielt von',
      descriptions: {
        malcolm: 'Malcolm ist der dritte von fünf Brüdern mit einem Genie-IQ (165). Bekannt für seine geistreichen Beobachtungen und scharfen sozialen Kommentare, durchbricht er oft die vierte Wand, um seine Einsichten über Familie, Gesellschaft und die Absurditäten des Lebens zu teilen. Während seine Intelligenz ihm hilft, die Welt um ihn herum zu verstehen, macht sie ihn auch besonders empfänglich für die Komplexitäten und Ironien des Lebens.',
        dewey: 'Dewey ist der vierte von fünf Brüdern, mit Francis, Reese und Malcolm als älteren Brüdern und Jamie als jüngerem Bruder. Obwohl oft übersehen, zeigt er erstaunliches musikalisches Talent, Anpassungsfähigkeit und Kreativität. Seine einzigartige Fantasie und künstlerischen Fähigkeiten lassen ihn in dieser chaotischen Familie herausstechen.',
        reese: 'Reese ist der zweitälteste von fünf Brüdern, zwischen Francis und Malcolm. Trotz schlechter schulischer Leistungen zeigt er außergewöhnliches Talent beim Kochen. Obwohl er oft Ärger macht, zeigt er gelegentlich unerwartete Weisheit und Loyalität gegenüber seinen Brüdern.',
        francis: 'Francis ist der älteste der fünf Brüder. Seine rebellische Natur führte ihn zur Militärschule, wo er mehrere Lebensveränderungen erfuhr. Seine Konflikte mit seiner Mutter und seine persönliche Entwicklung veranschaulichen die Komplexität familiärer Beziehungen.',
        jamie: 'Jamie ist der jüngste der fünf Brüder, geboren in der vierten Staffel. Hoewel er das Baby der Familie ist, pas hij zich snell aan aan die chaotische Familiendynamik an. Seine Ankunft fügt den Familienbeziehungen neue Dimensionen hinzu und wird oft zum Mittelpunkt von sowohl Unfug als auch Zuneigung.',
        lois: 'Als Mutter von fünf Jungen ist Lois streng, aber liebevoll. Sie hält die Familienordnung unter schwierigen Bedingungen aufrecht und bewältigt Francis\' Rebellion, Reeses Unfug, Malcolms Genialität, Deweys Kreativität und Jamies Aufwachsen.',
        hal: 'Vater Hal mag mit fünf Söhnen überfordert erscheinen, ist aber voller Weisheit und Liebe. Sein einzigartiger Erziehungsstil und seine bedingungslose Unterstützung zeigen eine andere Form väterlicher Liebe, wobei er oft kreative Wege findet, sich mit jedem seiner sehr unterschiedlichen Jungen zu verbinden.'
      }
    },
    quotes: {
      title: 'Klassische Zitate',
      season: 'Staffel',
      episode: 'Episode',
      character: 'Charakter',
      seasonTitle: 'Staffel {{number}} - Klassische Zitate'
    },
    footer: {
      about: 'Über uns',
      aboutText: 'Diese Website ist der Serie Malcolm mittendrin gewidmet. Alle Inhalte stammen aus öffentlichen Quellen und dienen Lern- und Kommunikationszwecken. Diese Website steht in keiner Verbindung zum ursprünglichen Produktionsteam, alle Rechte liegen bei den ursprünglichen Rechteinhabern.',
      contact: 'Kontakt',
      disclaimer: 'Bei Urheberrechtsverletzungen kontaktieren Sie uns bitte zur Entfernung.'
    }
  },
  nl: {
    nav: {
      intro: 'Introductie',
      characters: 'Personages',
      quotes: 'Citaten',
      quiz: 'Persoonlijkheidstest',
      features: 'Functies',
      explore: 'Verken de serie-inhoud'
    },
    home: {
      title: 'Malcolm in the Middle',
      subtitle: 'Een klassieke familiekomedie',
      description: 'Ontdek het gekke leven van Malcolm en zijn familie',
      welcome: 'Welkom bij Malcolm in the Middle',
      welcomeDesc: 'Ontdek dit gekke maar hartverwarmende familieverhaal.',
      about: 'Over de serie',
      aboutText: 'Deze serie volgt het dagelijks leven van een middenklasse gezin door de ogen van Malcolm, een begaafde tiener.\n\n' +
        'Seizoen 1 (2000):\n' +
        'Malcolm ontdekt zijn geniestatus en wordt overgeplaatst naar de begaafdenklas, terwijl zijn oudste broer Francis rebelleert op de militaire school.\n\n' +
        'Seizoen 2 (2000-2001):\n' +
        'Diepere verkenning van de gezinsdynamiek, Malcolms tienerworstelingen, Reese\'s culinaire talenten en Hals unieke interacties met de kinderen.\n\n' +
        'Seizoen 3 (2001-2002):\n' +
        'Grote veranderingen in het gezin, waaronder een memorabele gezinsvakantie, Lois\' unerwarte zwangerschap en Francis die nieuw werk vindt in Alaska.\n\n' +
        'Seizoen 4 (2002-2003):\n' +
        'Verwelkoming van nieuw gezinslid Jamie, Malcolms psychologische uitdagingen en Hals racewagen dromen.\n\n' +
        'Seizoen 5 (2003-2004):\n' +
        'Belangrijke overgangen met Francis die een nieuw leven begint op de ranch, Reese\'s impulsive militaire dienst en Malcolms eerste werkervaring.\n\n' +
        'Seizoen 6 (2004-2005):\n' +
        'Complexere gezinsdynamiek met oma Ida die intrekt, Dewey\'s bloeiende muzikale talenten en Malcolm die zich voorbereidt op universiteitstoelatingen.\n\n' +
        'Seizoen 7 (2005-2006):\n' +
        'Het laatste seizoen toont cruciale momenten voor elk personage: Malcolms acceptatie op Harvard, Reese die zijn weg vindt, en de familie die samen toekomstige veranderingen tegemoet gaat.\n\n' +
        'De serie staat bekend om zijn unieke vertelstijl, uitstekende acteerprestaties en geestige script dat zowel de vreugde als de uitdagingen van het gezinsleven laat zien.',
      features: 'Show kenmerken',
      awards: 'Prijzen & erkenning',
      awardsText: 'De serie heeft vele prijzen ontvangen, waaronder 7 Emmy Awards, een Grammy Award en een Peabody Award. Bryan Cranston ontving 3 Emmy-nominaties voor zijn rol als Hal, terwijl de serie consistent werd geprezen voor zijn innovatieve vertelwijze en uitstekende ensemble-uitvoering.',
      contact: 'Voor suggesties, mail naar: garygxm@gmail.com'
    },
    quiz: {
      title: 'Op welk personage lijk jij?',
      start: 'Start test',
      next: 'Volgende vraag',
      result: 'Bekijk resultaat',
      disclaimer: 'Deze test is alleen voor entertainment.',
      matchLevel: 'Overeenkomstniveau',
      traits: 'Karaktereigenschappen',
      retake: 'Test opnieuw doen',
      question: 'Vraag',
      questionNumber: 'Vraag {{current}}/{{total}}',
      allMatches: 'Alle personages passen',
      recommendedEpisodes: 'Aanbevolen afleveringen',
      seasonEpisode: 'Seizoen {{season}} Episode {{episode}}',
      similarCharacters: 'Gelijke personages',
      questions: {
        daily: 'Wat doe je meestal?',
        difficulty: 'Hoe ga je om met moeilijkheden?',
        weekend: 'Wat wil je in het weekend doen?',
        strength: 'Wat denk je dat je grootste sterkte is?',
        familyRole: 'Welke rol speel je meestal in het gezin?',
        lifestyle: 'Welke levensstijl streef je na?',
        rules: 'Wat is je houding tegenover regels?',
        hobby: 'Wat is je favoriete vrijetijdsbesteding?'
      }
    },
    characters: {
      title: 'Karakterprofielen',
      subtitle: 'Leer elk uniek karakter kennen',
      traits: 'Karaktereigenschappen',
      memorableMoments: 'Gedenkwaardige momenten',
      actor: 'Gespield door',
      descriptions: {
        malcolm: 'Malcolm is de derde van vijf broers met een geniaal IQ (165). Bekend om zijn scherpe observaties en sociale commentaar, doorbreekt hij vaak de vierde wand om zijn inzichten over familie, maatschappij en de absurditeit van het leven te delen. Hoewel zijn intelligentie hem helpt de wereld om hem heen te begrijpen, maakt het hem ook bijzonder bewust van de complexiteit en ironie van het leven.',
        dewey: 'Dewey is de vierde van vijf broers, met Francis, Reese en Malcolm als oudere broers en Jamie als jongere broer. Hoewel vaak over het hoofd gezien, toont hij verbazingwekkend muzikaal talent, aanpassingsvermogen en creativiteit. Zijn unieke verbeelding en artistieke vaardigheden laten hem opvallen in dit chaotische gezin.',
        reese: 'Reese is de op één na oudste van vijf broers, tussen Francis en Malcolm. Ondanks slechte schoolprestaties toont hij buitengewoon talent in koken. Hoewel hij vaak problemen veroorzaakt, laat hij soms onverwachte wijsheid en loyaliteit aan zijn broers zien.',
        francis: 'Francis is de oudste van de vijf broers. Zijn rebelse natuur leidde hem naar de militaire school, waar hij verschillende levensveranderingen onderging. Zijn conflicten met zijn moeder en persoonlijke groei illustreren de complexiteit van familierelaties.',
        jamie: 'Jamie is de jongste van de vijf broers, geboren in het vierde seizoen. Hoewel hij de benjamin van het gezin is, pas hij zich snel aan aan de chaotische gezinsdynamiek. Zijn komst voegt nieuwe dimensies toe aan de familierelaties en wordt vaak het middelpunt van zowel kattenkwaad als genegenheid.',
        lois: 'Sebagai ibu kepada lima orang anak lelaki, Lois tegas tetapi penyayang. Dia mengekalkan ketenteraman keluarga dalam keadaan yang sukar, menangani pemberontakan Francis, kenakalan Reese, kepintaran Malcolm, kreativiti Dewey, dan tahun-tahun tumbesaran Jamie.',
        hal: 'Bapa Hal mungkin kelihatan kewalahan dengan lima orang anak lelaki, tetapi dia penuh dengan kebijaksanaan dan kasih sayang. Gaya keibubapaan unik dan sokongan tanpa syaratnya menunjukkan bentuk kasih sayang bapa yang berbeza, sering mencari cara kreatif untuk berhubung dengan setiap anak lelakinya yang sangat berbeza.'
      }
    },
    quotes: {
      title: 'Klassieke citaten',
      season: 'Seizoen',
      episode: 'Aflevering',
      character: 'Personage',
      seasonTitle: 'Seizoen {{number}} - Klassieke citaten'
    },
    footer: {
      about: 'Over',
      aboutText: 'Deze website is gewijd aan de serie Malcolm in the Middle. Alle content komt uit openbare bronnen en is bedoeld voor leer- en communicatiedoeleinden. Deze site heeft geen banden met het originele productieteam, en alle rechten behoren toe aan de oorspronkelijke rechthebbenden.',
      contact: 'Contact',
      disclaimer: 'Bij inbreuk op auteursrecht, neem contact op voor verwijdering.'
    }
  },
  ms: {
    nav: {
      intro: 'Pengenalan',
      characters: 'Watak-watak',
      quotes: 'Petikan',
      quiz: 'Ujian Personaliti',
      features: 'Fungsi',
      explore: 'Terokai Kandungan Rancangan'
    },
    home: {
      title: 'Malcolm in the Middle',
      subtitle: 'Komedi Keluarga Klasik',
      description: 'Terokai kehidupan gila Malcolm dan keluarganya',
      welcome: 'Selamat datang ke Malcolm in the Middle',
      welcomeDesc: 'Terokai kisah keluarga yang gila tapi menghangatkan hati ini.',
      about: 'Mengenai Rancangan',
      aboutText: 'Siri ini mengikuti kehidupan harian sebuah keluarga kelas menengah melalui perspektif Malcolm, seorang remaja berbakat.\n\n' +
        'Musim 1 (2000):\n' +
        'Malcolm mendapati status geniusnya dan dipindahkan ke kelas berbakat, sementara abang sulungnya Francis memberontak di sekolah tentera.\n\n' +
        'Musim 2 (2000-2001):\n' +
        'Mendalami dinamik keluarga, cabaran remaja Malcolm, bakat memasak Reese, dan interaksi unik Hal dengan anak-anak.\n\n' +
        'Musim 3 (2001-2002):\n' +
        'Perubahan besar dalam keluarga, termasuk percutian keluarga yang tidak dapat dilupakan, kehamilan Lois yang tidak dijangka, dan Francis mendapat kerja baru di Alaska.\n\n' +
        'Musim 4 (2002-2003):\n' +
        'Menyambut ahli keluarga baru Jamie, cabaran psikologi Malcolm dan impian kereta lumba Hal.\n\n' +
        'Musim 5 (2003-2004):\n' +
        'Peralihan penting dengan Francis memulakan kehidupan baru di ladang, Reese menyertai tentera secara impulsif, dan pengalaman kerja pertama Malcolm.\n\n' +
        'Musim 6 (2004-2005):\n' +
        'Dinamik keluarga menjadi lebih kompleks dengan Nenek Ida berpindah masuk, bakat muzik Dewey berkembang, dan Malcolm bersedia untuk permohonan kolej.\n\n' +
        'Musim 7 (2005-2006):\n' +
        'Musim terakhir menampilkan saat-saat penting bagi setiap watak: Malcolm diterima masuk ke Harvard, Reese menemui haluannya, dan keluarga bersama-sama menghadapi perubahan masa depan.\n\n' +
        'Siri ini terkenal dengan gaya penceritaan yang unik, lakonan yang cemerlang dan skrip yang bijak yang mendedahkan kegembiraan dan cabaran kehidupan berkeluarga.',
      features: 'Ciri-ciri Rancangan',
      awards: 'Anugerah & Pengiktirafan',
      awardsText: 'Siri ini telah menerima banyak anugerah, termasuk 7 Anugerah Emmy, satu Anugerah Grammy dan satu Anugerah Peabody. Bryan Cranston menerima 3 pencalonan Emmy untuk peranannya sebagai Hal, manakala siri ini sentiasa dipuji untuk penceritaan inovatif dan persembahan ensemble yang cemerlang.',
      contact: 'Untuk cadangan, emel ke: garygxm@gmail.com'
    },
    quiz: {
      title: 'Anda Paling Mirip Watak Mana?',
      start: 'Mula Ujian',
      next: 'Soalan Seterusnya',
      result: 'Lihat Keputusan',
      disclaimer: 'Ujian ini hanya untuk hiburan sahaja.',
      matchLevel: 'Tahap Padanan',
      traits: 'Ciri-ciri Personaliti',
      retake: 'Cuba Semula Ujian',
      question: 'Soalan',
      questionNumber: 'Soalan {{current}}/{{total}}',
      allMatches: 'Semua watak sesuai',
      recommendedEpisodes: 'Episode yang Direkomen',
      seasonEpisode: 'Musim {{season}} Episode {{episode}}',
      similarCharacters: 'Watak yang Serupa',
      questions: {
        daily: 'Apa yang anda selalu lakukan?',
        difficulty: 'Bagaimana anda menangani kesukaran?',
        weekend: 'Apa yang anda ingin lakukan pada hujung minggu?',
        strength: 'Apa yang anda fikir kekuatan terbesar anda?',
        familyRole: 'Apakah peranan yang anda biasa mainkan dalam keluarga?',
        lifestyle: 'Gaya hidup apakah yang anda inginkan?',
        rules: 'Apakah sikap anda terhadap peraturan?',
        hobby: 'Apakah aktiviti masa lapang kegemaran anda?'
      }
    },
    characters: {
      title: 'Profil Watak',
      subtitle: 'Kenali setiap watak unik',
      traits: 'Ciri-ciri Personaliti',
      memorableMoments: 'Saat-saat Bersejarah',
      actor: 'Diperankan oleh',
      descriptions: {
        malcolm: 'Malcolm adalah anak ketiga daripada lima beradik dengan IQ genius (165). Terkenal dengan pemerhatian bijak dan komen sosial yang tajam, dia sering memecahkan dinding keempat untuk berkongsi pandangannya tentang keluarga, masyarakat, dan kejanggalan kehidupan. Walaupun kepintarannya membantu dia memahami dunia di sekelilingnya, ia juga membuatnya sangat sedar akan kerumitan dan ironi kehidupan.',
        dewey: 'Dewey adalah anak keempat daripada lima beradik, dengan Francis, Reese, dan Malcolm sebagai abang dan Jamie sebagai adik. Walaupun sering diabaikan, dia menunjukkan bakat muzik yang mengagumkan, kebolehan menyesuaikan diri, dan kreativiti. Imaginasi unik dan kebolehan artistiknya membuatnya menonjol dalam keluarga yang kacau-bilau ini.',
        reese: 'Reese adalah anak kedua tertua daripada lima beradik, antara Francis dan Malcolm. Walaupun prestasi akademik yang lemah, dia menunjukkan bakat luar biasa dalam memasak. Walaupun sering menimbulkan masalah, kadang-kadang dia menunjukkan kebijaksanaan tidak terduga dan kesetiaan kepada adik-beradiknya.',
        francis: 'Francis adalah yang sulung daripada lima beradik. Sifat memberontaknya membawanya ke sekolah tentera, di mana dia mengalami pelbagai perubahan hidup. Konfliknya dengan ibunya dan perkembangan peribadinya menggambarkan kerumitan hubungan keluarga.',
        jamie: 'Jamie adalah yang bongsu daripada lima beradik, dilahirkan dalam musim keempat. Walaupun dia yang termuda dalam keluarga, dia cepat menyesuaikan diri dengan dinamik keluarga yang kacau-bilau. Kedatangannya menambah dimensi baru kepada hubungan keluarga dan sering menjadi pusat kenakalan dan kasih sayang.',
        lois: 'Sebagai ibu kepada lima orang anak lelaki, Lois tegas tetapi penyayang. Dia mengekalkan ketenteraman keluarga dalam keadaan yang sukar, menangani pemberontakan Francis, kenakalan Reese, kepintaran Malcolm, kreativiti Dewey, dan tahun-tahun tumbesaran Jamie.',
        hal: 'Bapa Hal mungkin kelihatan kewalahan dengan lima orang anak lelaki, tetapi dia penuh dengan kebijaksanaan dan kasih sayang. Gaya keibubapaan unik dan sokongan tanpa syaratnya menunjukkan bentuk kasih sayang bapa yang berbeza, sering mencari cara kreatif untuk berhubung dengan setiap anak lelakinya yang sangat berbeza.'
      }
    },
    quotes: {
      title: 'Petikan Klasik',
      season: 'Musim',
      episode: 'Episod',
      character: 'Watak',
      seasonTitle: 'Musim {{number}} - Petikan Klasik'
    },
    footer: {
      about: 'Mengenai',
      aboutText: 'Laman web ini didedikasikan untuk siri Malcolm in the Middle. Semua kandungan adalah dari sumber awam untuk tujuan pembelajaran dan komunikasi. Laman web ini tidak mempunyai kaitan dengan pasukan produksi asal, dan semua hak milik pemegang hak cipta asal.',
      contact: 'Hubungi Kami',
      disclaimer: 'Jika ada pelanggaran hak cipta, sila hubungi kami untuk pembuangan.'
    }
  }
}; 